import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
const API_BASE_URL = 'https://api.fastfin.com'; // Replace with actual API URL

export const verifyMobile = createAsyncThunk(
  'onboarding/verifyMobile',
  async (mobileNumber, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/verify-mobile`, { mobileNumber });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const verifyOTP = createAsyncThunk(
  'onboarding/verifyOTP',
  async ({ mobileNumber, otp }, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/verify-otp`, { mobileNumber, otp });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const fetchPANDetails = createAsyncThunk(
  'onboarding/fetchPANDetails',
  async (panNumber, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/pan-details/${panNumber}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const onboardingSlice = createSlice({
  name: 'onboarding',
  initialState: {
    step: 'mobileNumber',
    mobileNumber: '',
    otpVerified: false,
    panNumber: '',
    userDetails: null,
    loading: false,
    error: null,
  },
  reducers: {
    setStep: (state, action) => {
      state.step = action.payload;
    },
    setMobileNumber: (state, action) => {
      state.mobileNumber = action.payload;
    },
    setPanNumber: (state, action) => {
      state.panNumber = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(verifyMobile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(verifyMobile.fulfilled, (state) => {
        state.loading = false;
        state.step = 'otpVerification';
      })
      .addCase(verifyMobile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(verifyOTP.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(verifyOTP.fulfilled, (state) => {
        state.loading = false;
        state.otpVerified = true;
        state.step = 'panEntry';
      })
      .addCase(verifyOTP.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchPANDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPANDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.userDetails = action.payload;
        state.step = 'confirmation';
      })
      .addCase(fetchPANDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setStep, setMobileNumber, setPanNumber } = onboardingSlice.actions;
export default onboardingSlice.reducer;